/**
 * @file
 * Distribution details toggle behavior.
 *
 * Implements accordion-style expand/collapse for distribution detail items
 * using Drupal behaviors pattern with once() for proper attachment.
 */

((Drupal, once) => {
  const EXPANDED_CLASS = 'is-expanded';
  const TOGGLE_SELECTOR = '[data-toggle-details]';

  Drupal.behaviors.datasetDistributionsToggle = {
    attach(context) {
      // Use once() to prevent multiple initializations on the same elements.
      const toggleButtons = once('dist-toggle', TOGGLE_SELECTOR, context);

      for (const button of toggleButtons) {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          // Find the parent item card
          const itemCard = button.closest('.dataset-distributions__item');
          if (!itemCard) {
            return;
          }

          const showLabel = button.getAttribute('data-label-show') || button.getAttribute('aria-label');
          const hideLabel = button.getAttribute('data-label-hide') || button.getAttribute('aria-label');
          const isCurrentlyExpanded = itemCard.classList.contains(EXPANDED_CLASS);

          // Accordion behavior: close other expanded items first.
          const container = button.closest('.dataset-distributions');
          if (container) {
            const expandedItems = container.querySelectorAll(`.dataset-distributions__item.${EXPANDED_CLASS}`);
            for (const item of expandedItems) {
              if (item === itemCard) {
                continue;
              }

              item.classList.remove(EXPANDED_CLASS);

              // Update corresponding button.
              const otherButton = item.querySelector(TOGGLE_SELECTOR);
              if (otherButton) {
                otherButton.classList.remove(EXPANDED_CLASS);
                otherButton.setAttribute('aria-expanded', 'false');

                const otherShowLabel =
                  otherButton.getAttribute('data-label-show') || otherButton.getAttribute('aria-label');
                if (otherShowLabel) {
                  otherButton.setAttribute('aria-label', otherShowLabel);
                  otherButton.setAttribute('title', otherShowLabel);
                }
              }
            }
          }

          // Toggle current item.
          if (isCurrentlyExpanded) {
            itemCard.classList.remove(EXPANDED_CLASS);
            button.classList.remove(EXPANDED_CLASS);
            button.setAttribute('aria-expanded', 'false');
            if (showLabel) {
              button.setAttribute('aria-label', showLabel);
              button.setAttribute('title', showLabel);
            }
            return;
          }

          itemCard.classList.add(EXPANDED_CLASS);
          button.classList.add(EXPANDED_CLASS);
          button.setAttribute('aria-expanded', 'true');
          if (hideLabel) {
            button.setAttribute('aria-label', hideLabel);
            button.setAttribute('title', hideLabel);
          }
        });
      }
    },

    detach(context, _settings, trigger) {
      // Clean up on unload to prevent memory leaks.
      if (trigger === 'unload') {
        once.remove('dist-toggle', TOGGLE_SELECTOR, context);
      }
    },
  };
})(Drupal, once);
